import { useState, useEffect } from 'react';
import api from '../utils/api';

export const useEmailLimits = () => {
  const [limits, setLimits] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLimits = async () => {
      try {
        const response = await api.get('/api/subscribe/limits');
        setLimits(response.data);
      } catch (err) {
        console.error('Error fetching limits:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchLimits();
  }, []);

  const canSendEmail = (count = 1) => {
    if (!limits) return false;
    const remaining = limits.limits.maxEmailsPerMonth - limits.usage.emails;
    return remaining >= count;
  };

  const getUpgradeMessage = () => {
    if (!limits) return null;
    const nextPlanName = limits.nextPlan?.name || 'a higher plan';
    const nextPlanLimit = limits.nextPlan?.limits?.maxEmailsPerMonth || 'more';
    return {
      title: 'Email Limit Reached',
      message: `You've reached your email sending limit (${limits.limits.maxEmailsPerMonth} emails/month) for the ${limits.planName} plan. Upgrade to ${nextPlanName} to send up to ${nextPlanLimit} emails/month.`,
      currentUsage: limits.usage.emails,
      limit: limits.limits.maxEmailsPerMonth,
      currentPlan: limits.planName,
      nextPlan: nextPlanName,
      nextPlanLimit: nextPlanLimit,
      upgradeUrl: '/pricing'
    };
  };

  return { limits, loading, canSendEmail, getUpgradeMessage };
};

